import {Box, Stack} from '@chakra-ui/react';
import {GeoLink} from 'components/action/GeoLink';
import {GeoHeaderText} from 'components/text/GeoHeaderText';
import {GeoSubheaderText} from 'components/text/GeoSubheaderText';
import {GeoSubtitleText} from 'components/text/GeoSubtitleText';
import {useTranslation} from 'modules/i18n';
import React from 'react';
import {useResponsive} from 'utils/useResponsive';

export const LoginLegend: React.FC = () => {
	const {t} = useTranslation();
	const {isMobile} = useResponsive();

	return (
		<>
			<Stack spacing={2} direction='column'>
				<GeoSubheaderText>{t('auth.subHeaderLogin')}</GeoSubheaderText>
				<GeoHeaderText>{t('auth.signIn')}</GeoHeaderText>
				<Box marginTop={2}>
					<Stack spacing={2} direction={isMobile ? 'column' : 'row'}>
						<GeoSubtitleText>{t('auth.askAccount')}</GeoSubtitleText>
						<GeoLink
							color='geoBlue.500'
							label={t('auth.signUp')}
							to='authSignup'
							data-cy='link-signup'
						/>
					</Stack>
				</Box>
			</Stack>
		</>
	);
};
